import axios from "axios";
import { API_BASE_URL } from "../constants";
import { isJwtExpired } from "../utils/jwt";
import getValidFirebaseToken from "../utils/valid_firebase_token";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor - basit ve orijinal hali
axiosInstance.interceptors.request.use(async (config) => {
  try {
    let token = localStorage.getItem("authToken");
    if (token && isJwtExpired(token)) {
      token = await getValidFirebaseToken();
    }
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  } catch (error) {
    console.error("Request error:", error);
    return Promise.reject(error);
  }
});

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
